// <s-recently-viewed>: records product views in localStorage and renders a row of earlier views.
const STORAGE_KEY = 'rosedrick:recently-viewed';
const MAX_ITEMS = 8;

function readItems() {
  try {
    const items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(items) ? items.filter((item) => item && item.handle && item.url) : [];
  } catch {
    return [];
  }
}

function writeItems(items) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_ITEMS + 1)));
  } catch {
    // Storage can be unavailable (private mode, quota); the row simply stays hidden.
  }
}

class RecentlyViewed extends HTMLElement {
  connectedCallback() {
    const current = this.dataset.current || '';
    let items = readItems();

    const recordEl = this.querySelector('[data-record]');
    if (recordEl) {
      try {
        const record = JSON.parse(recordEl.textContent || '{}');
        if (record.handle) {
          items = [record, ...items.filter((item) => item.handle !== record.handle)];
          writeItems(items);
        }
      } catch {
        // Ignore malformed record data.
      }
    }

    const visible = items.filter((item) => item.handle !== current).slice(0, MAX_ITEMS);
    const list = this.querySelector('[data-list]');
    const template = this.querySelector('template[data-card]');
    if (!visible.length || !list || !(template instanceof HTMLTemplateElement)) return;

    const fragment = document.createDocumentFragment();
    for (const item of visible) {
      const card = template.content.cloneNode(true);
      const link = card.querySelector('[data-link]');
      const image = card.querySelector('[data-image]');
      const title = card.querySelector('[data-title]');
      const price = card.querySelector('[data-price]');
      const compare = card.querySelector('[data-compare]');
      if (link) link.href = item.url;
      if (image) {
        if (item.image) image.src = item.image;
        else image.remove();
      }
      if (title) title.textContent = item.title || '';
      if (price) price.textContent = item.price || '';
      if (compare) {
        if (item.compare) compare.textContent = item.compare;
        else compare.remove();
      }
      fragment.append(card);
    }
    list.replaceChildren(fragment);
    this.hidden = false;
  }
}

if (!customElements.get('s-recently-viewed')) customElements.define('s-recently-viewed', RecentlyViewed);
